export default "__VITE_ASSET__AxiX9Ivs__"